export default __webpack_public_path__ + "static/media/battlexo-icon.1359a53b.png";